import React, { Component } from 'react';
import UserRow from './UserRow'
import { Table } from 'semantic-ui-react';

const header_labels = [
{
  label:'Active'
},
{
  label:'Name'
},
{
  label:'Email'
},
{
  label:'Last Graded'
},
{
  label:'Admin'
},
{
  label:'Make Admin'
}
]

class UsersTable extends Component {
  constructor(props) {
    super(props);    
    this.state = {
    }
  }

  render(){
    let header = header_labels.map((item) => 
      <Table.HeaderCell key={item.label}>{item.label}</Table.HeaderCell>
    );    
    

    //go through the rows
    let rows = []
    for(let i=0; i < this.props.data.length; i++){
      let highlight = this.props.data[i].admin ? 'positive':null
      rows.push(
          <UserRow data={this.props.data[i]} hl={highlight} />
      )
    }
    
   return (
    <Table sortable singleLine selectable>
      <Table.Header>
        <Table.Row>
          {header}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {rows}
      </Table.Body>
    </Table>
      )
  }
  
}


export default UsersTable;


// WEBPACK FOOTER //
// ./src/components/admin/users_table/UsersTable.js